exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".send-value {\r\n\tfont-weight: bold;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/confirmacion/confirmacion.component.css
// module id = ../../../../../src/app/modules/recuperar-pass/components/confirmacion/confirmacion.component.css
// module chunks = main